import React, { useEffect, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faImage, 
    faList, 
    faLayerGroup, // Icono sugerido para subcategorías
    faBoxesStacked // Icono alternativo
} from '@fortawesome/free-solid-svg-icons'; 
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';

export default function CardsCantidad() {
    const [servicios, setServicios] = useState([]);
    const [banners, setBanners] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubCategorias] = useState([]);

    useEffect(() => {
        cargarServicios();
        cargarBanners();
        cargarCategoria();
        cargarSubCategoria();
    }, []);

    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
            })
            .catch(error => console.error('Error al cargar banners:', error));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSubCategorias(data.subcategorias || []);
                console.log(data.subcategorias);
            })
            .catch(error => console.error('Error al cargar subcategorías:', error));
    };

    return (
        <div className='CardsCantidad'>
            {/* Reemplazado Usuarios por Banners */}
            <Anchor to={`/dashboard/banners`} className='cardCantidad'>
                <FontAwesomeIcon icon={faImage} className='icons' />
                <div className='deColumn'>
                    <h3>Banners</h3>
                    <h2>{banners.length}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/servicios`} className='cardCantidad'>
                <FontAwesomeIcon icon={faProductHunt} className='icons' />
                <div className='deColumn'>
                    <h3>Productos</h3>
                    <h2>{servicios.length}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/categorias`} className='cardCantidad'>
                <FontAwesomeIcon icon={faList} className='icons' />
                <div className='deColumn'>
                    <h3>Categorías</h3>
                    <h2>{categorias.length}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/categorias`} className='cardCantidad'>
                <FontAwesomeIcon icon={faLayerGroup} className='icons' />
                <div className='deColumn'>
                    <h3>Subcategorías</h3>
                    <h2>{subcategorias.length}</h2>
                </div>
            </Anchor>
        </div>
    );
}